import { Routes } from '@angular/router';
import { routes as appsRoutes } from './apps/apps.routes';
import { AppResolverFn } from './apps/resolvers/app.resolver';
import { routes as configRoutes } from './config/config.routes';
import { childrenAuthGuard } from './core/auth';
import { canDeactivateAppFn } from './core/guards/app.guard';
import { modalGuard } from './core/guards/modal.guard';
import { databasesResolverFn } from './data-management/resolvers/databases.resolver';
import { routes as deploymentRoutes } from './deployments-history/deployment-history.routes';
import { routes as marketplaceRoutes } from './marketplace/marketplace.routes';
import { routes as pageDesignerRoutes } from './page-designer/page-designer.routes';
import { routes as userManagementRoutes } from './user-management/user-management.routes';
import { routes as viewManagementRoutes } from './view-management/view-management.routes';
import { routes as groupManagementRoutes } from './group-management/group-management.routes';
import { widgetResolverFn } from './widget-management/resolvers/widget.resolver';
import { pageResolverFn } from './core/resolvers/page.resolver';

export const routes: Routes = [
	{
		path: '',
		children: [
			{
				path: 'apps/:appId/views/:pageId',
				resolve: {
					app: AppResolverFn,
					page: pageResolverFn
				},
				canDeactivate: [canDeactivateAppFn, modalGuard],
				children: pageDesignerRoutes
			},
			{
				path: 'apps/:appId/widgets/:widgetId',
				resolve: {
					app: AppResolverFn,
					widget: widgetResolverFn,
					databases: databasesResolverFn
				},
				canDeactivate: [canDeactivateAppFn, modalGuard],
				loadComponent: () =>
					import(
						'./widget-management/components/widget-designer/widget-designer.component'
					).then((component) => component.WidgetDesignerComponent)
			},
			{
				path: '',
				data: { breadcrumb: 'GENERIC.TITLES.HOME_BREADCRUMB' },
				loadComponent: () =>
					import('./layout/components/wrapper/wrapper.component').then(
						(component) => component.WrapperComponent
					),
				canActivateChild: [childrenAuthGuard],
				canDeactivate: [modalGuard],
				children: [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'apps'
					},
					{
						path: 'apps',
						data: { breadcrumb: 'APP_LIST.BREADCRUMBS.MAIN' },
						children: appsRoutes
					},
					{
						path: 'config',
						children: configRoutes
					},
					{
						path: 'views',
						children: viewManagementRoutes
					},
					{
						path: 'user-management',
						children: userManagementRoutes
					},
					{
						path: 'group-management',
						children: groupManagementRoutes
					},
					{
						path: 'marketplace',
						data: { breadcrumb: 'MARKETPLACE.TITLES.MAIN' },
						children: marketplaceRoutes
					},
					{
						path: 'deployments',
						children: deploymentRoutes
					},
					{
						path: 'bpmns',
						loadComponent: () =>
							import(
								'./bpmn-management/components/bpmn-detail/bpmn-detail.component'
							).then((component) => component.BpmnDetailComponent)
					}
				]
			},
			{
				path: 'auth',
				loadChildren: () =>
					import('@core/auth/auth-routing.module').then(
						(module) => module.AuthRoutingModule
					)
			},
			{
				path: 'error',
				loadComponent: () =>
					import('./error/error.component').then(
						(component) => component.ErrorComponent
					)
			}
		]
	}
];
